import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Tooltip } from '@material-ui/core';
import { useDispatch } from 'react-redux';

import defaultAvatar from '../../assets/images/avatar/avatar-default.png';
import { logout } from '../../store/slices/auth';

const UserMenuDropDown = (props) => {

    const dispatch = useDispatch();
    const [isActive, setActive] = useState(false);
    const [profileImage, setProfileImage] = useState("");
   
    useEffect(() => {
        if(props.user.photo === 'no-image') {
			setProfileImage(defaultAvatar)
        } else {
            setProfileImage(props.user.photo)
        }
    }, [props.user.photo]);

    const handleToggle = () => {
        setActive(!isActive);
    }

    function addDefaultSrc(e) {
        e.target.src = defaultAvatar;
    }

    return (
        <div 
            className={isActive ? 'header-user-menu sub_user hu-menu-visdec' : 'header-user-menu sub_user'} 
            onClick={handleToggle}
        >
            <>
                <div className="header-user-name"> 
                    {profileImage &&
                        <span>
                            <img 
                                src={profileImage} 
                                alt={props.user.first_name}
                                onError={addDefaultSrc} 
                            />
                        </span>  
                    }
                </div>
                <ul className={isActive ? 'hu-menu-vis menuBox' : 'menuBox'}>
                    <li className="arrowBox">
                        <div className="drop-menu-arrow"></div>
                    </li>
                    <li className="userDetails">
                        <Link to="/user/dashboard">
                            <img 
                                src={profileImage} 
                                alt={props.user.first_name} 
                                className="user_image"
                                onError={addDefaultSrc}  
                            />    
                        </Link>
                        <div className="userData">
                            <Link to={`/profile/${props.user.slug}/home`} target="_blank">{props.user.first_name} {props.user.last_name}</Link>
                            {props.user.city ?
                                <p>{props.user.city}, {props.user.country ? props.user.country : ""}</p>
                                :
                                <p>Location N/A</p>
                            }
                            <div className="reviewRating">
                                <Tooltip title="Followers">
                                    <span><i className="fas fa-user-plus"></i>{props.user.total_followers}</span>
                                </Tooltip>
                                <Tooltip title="Reviews">
                                    <span><i className="fas fa-star"></i>{props.user.total_reviews}</span>
                                </Tooltip>
                                <Tooltip title="Like Votes">
                                    <span><i className="fas fa-heart"></i>{props.user.total_like_votes}</span>
                                </Tooltip>
                            </div>
                        </div>
                    </li>
                    <li className="innerLinks">
                        <Link to="/user/dashboard">
                            <i className="fas fa-user"></i> <span>My Dashboard</span>
                        </Link>
                    </li>
                    <li className="innerLinks">
                        <Link to="/people">
                            <i className="fas fa-search"></i> <span>Find Friends</span> 
                        </Link>
                    </li> 
                    <li className="innerLinks">
                        <Link to="/user/settings">
                            <i className="fas fa-cog"></i> <span>Account Settings</span> 
                        </Link>
                    </li>
                    <li className="innerLinks">
                        <Link to="#" onClick={() => dispatch(logout())}>
                            <i className="fas fa-sign-out"></i> <span>Log Out</span>
                        </Link>
                    </li>
                </ul>
            </>
        </div> 
    );
};

export default UserMenuDropDown;